import { render, staticRenderFns } from "./ModalDocumentosRegistroEntrada.vue?vue&type=template&id=d4a61450&scoped=true"
import script from "./ModalDocumentosRegistroEntrada.vue?vue&type=script&lang=js"
export * from "./ModalDocumentosRegistroEntrada.vue?vue&type=script&lang=js"
import style0 from "./ModalDocumentosRegistroEntrada.vue?vue&type=style&index=0&id=d4a61450&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4a61450",
  null
  
)

export default component.exports